
































import { Component, Vue } from "vue-property-decorator";
import { Senior } from "@/api/models/Senior";
import senioren from "@/api/content/senioren/senioren.json";

@Component
export default class HistorySenioren extends Vue {
    get senioren(): Array<Senior> {
        return senioren;
    }

    getTimelineColor(index: number): string {
        return index % 2 === 0 ? "primary" : "secondary";
    }
}
